import useHeaderChange from "@/hooks/useHeaderChange";
import { useParams } from "react-router";
import { useAccountsHeldElsewhere } from "@/hooks/useAccountsHeldElsewhere";
import NoDataMessage from "@/components/NoDataMessage";
import { AHESkeleton } from "./AHESkeletons";
import withDisclaimer from "@/hoc/withDisclaimer";
import AHEGrid from "./AHEGrid";
import Heading from "@/components/Heading";
import { formatNumber } from "devextreme/localization";

function AccountsHeldElsewhere() {
  const { id } = useParams();
  const { household } = useHeaderChange(id!, "Accounts Held Elsewhere");
  const { data, isLoading, isError, isRefetching } = useAccountsHeldElsewhere(id!);

  if (isLoading || isRefetching) return <AHESkeleton />;
  if (isError) return <div>Failed fetching Accounts Held Elsewhere</div>;
  if (!data?.data?.bankAccounts?.length && !data?.data?.nonBankAccounts?.length)
    return <NoDataMessage />;

  return (
    <div className="flex justify-center gap-8">
      <div className="flex w-1/3 flex-col gap-4">
        <Heading
          text={`Total Bank Account Balance: ${household?.totalBankAccountBalance ? formatNumber(household?.totalBankAccountBalance, "currency") : "—"}`}
        />
        <AHEGrid fas={data?.data?.bankAccounts} />
      </div>
      <div className="flex w-1/3 flex-col gap-4">
        <div className="flex justify-between">
          <Heading
            text={`Total AHE Fixed Income: ${household?.totalNonAONonBankFixedIncome ? formatNumber(household?.totalNonAONonBankFixedIncome, "currency") : "—"}`}
          />
          <Heading
            text={`Total AHE Balance: ${household?.totalNonAONonBankBalance ? formatNumber(household?.totalNonAONonBankBalance, "currency") : "—"}`}
          />
        </div>
        <AHEGrid fas={data?.data?.nonBankAccounts} />
      </div>
    </div>
  );
}

export default withDisclaimer(AccountsHeldElsewhere);
